export default {"src":"/_next/static/media/round-tick.5649a831.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};